import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { GeneralPowerOfAttorney as SectionKey } from 'Consts/Questionnaire';
import { section } from 'Consts/Queries';
import { QueryVal } from 'Helpers/Query';
import CircleWithCount from 'Icons/CircleWithCount';
import LabeledVerticalExpander from '../UI/LabeledVerticalExpander';
import Section from '../Section';
import FieldList from '../Fields/FieldList';
import TextInput from '../Fields/TextInput';
import TextareaInput from '../Fields/TextareaInput';
import DateInput from '../Fields/DateInput';
import USStateInput from '../Fields/USStateInput';

class GeneralPowerOfAttorneyForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: '',
    };
    this.handleTitleChange = this.handleTitleChange.bind(this);
  }

  handleTitleChange(key, val) {
    this.setState({ title: val });
  }

  render() {
    const { title } = this.state;
    const {
      props: { id, children: removeButton, expanded },
    } = this;
    return (
      <LabeledVerticalExpander
        transitionSpeed={0.25}
        title={title || 'New power of attorney'}
        removeButton={removeButton}
        firstElementFocusable
        expanded={expanded}
      >
        <TextInput
          name={`powerOfAttorneyPrincipal.${id}`}
          answerKey="powerOfAttorneyPrincipal"
          placeholder="Principal"
          onChange={this.handleTitleChange}
        />
        <DateInput
          name={`powerOfAttorneyDateExecuted.${id}`}
          answerKey="powerOfAttorneyDateExecuted"
          placeholder="Date executed"
        />
        <USStateInput
          name={`powerOfAttorneyStateExecuted.${id}`}
          answerKey="powerOfAttorneyStateExecuted"
          label="State in which executed:"
          value=""
        />
        <TextInput
          name={`powerOfAttorneyPrimaryAgent.${id}`}
          answerKey="powerOfAttorneyPrimaryAgent"
          placeholder="Agent (primary)"
        />
        <TextInput
          name={`powerOfAttorneySuccessorAgent.${id}`}
          answerKey="powerOfAttorneySuccessorAgent"
          placeholder="Agent (successor)"
        />
        <TextareaInput
          name={`powerOfAttorneyNotes.${id}`}
          answerKey="powerOfAttorneyNotes"
          placeholder="Notes"
        />
      </LabeledVerticalExpander>
    );
  }
}

GeneralPowerOfAttorneyForm.propTypes = {
  id: PropTypes.number.isRequired,
  children: PropTypes.any.isRequired,
  expanded: PropTypes.bool,
};

GeneralPowerOfAttorneyForm.defaultProps = {
  expanded: false,
};

const GeneralPowerOfAttorneySection = () => {
  const [count, setCount] = React.useState(0);

  return (
    <Section
      transitionSpeed={0.25}
      title="General power of attorney documents"
      sectionKey={SectionKey}
      expanded={QueryVal(section) === SectionKey}
      CountComponent={<CircleWithCount count={count} className="expander-header-count expander-header-left" />}
    >
      <FieldList
        onCountUpdate={setCount}
        label="Documents"
        addLabel="Add a power of attorney"
        keyPrefix="powerOfAttorney"
        Of={GeneralPowerOfAttorneyForm}
      />
    </Section>
  );
};

export default GeneralPowerOfAttorneySection;
